// extracted by mini-css-extract-plugin
export var readonly = "_i7-1";
export var star = "_i7-0";